import { Form, SignupForm, ChangePassForm, UserDetailsModal } from './ui';

export const UserInfo = {
  Form,
  SignupForm,
  ChangePassForm,
  UserDetailsModal,
};
